module.exports = __webpack_public_path__ + "static/development-video-eac1aca64e5eb40076e581b1661b0fb5.gif";